import './modal-box.css';
export default {
  "button": "pf-v6-c-button",
  "modalBox": "pf-v6-c-modal-box",
  "modalBoxBody": "pf-v6-c-modal-box__body",
  "modalBoxClose": "pf-v6-c-modal-box__close",
  "modalBoxDescription": "pf-v6-c-modal-box__description",
  "modalBoxFooter": "pf-v6-c-modal-box__footer",
  "modalBoxHeader": "pf-v6-c-modal-box__header",
  "modalBoxHeaderMain": "pf-v6-c-modal-box__header-main",
  "modalBoxTitle": "pf-v6-c-modal-box__title",
  "modalBoxTitleIcon": "pf-v6-c-modal-box__title-icon",
  "modalBoxTitleText": "pf-v6-c-modal-box__title-text",
  "modifiers": {
    "sm": "pf-m-sm",
    "md": "pf-m-md",
    "lg": "pf-m-lg",
    "alignTop": "pf-m-align-top",
    "danger": "pf-m-danger",
    "warning": "pf-m-warning",
    "success": "pf-m-success",
    "custom": "pf-m-custom",
    "info": "pf-m-info",
    "help": "pf-m-help",
    "icon": "pf-m-icon"
  }
};